import { createWebHistory, createRouter } from "vue-router";
import routes from "./routes";
import { useAuthStore } from "@/state/modules/auth";
import { mainMenu, collectUserRoles } from "@/router/mainMenu";
import { computed } from "vue";

let userStoreInitialised = false;

// Ролевой гейт на роутах (NANFin-XXX_sessions): раздел, на который нет прав, не
// должен открываться по прямому URL — раньше пускало любого авторизованного, а
// API отдавал 403 и рисовались пустые формы. Матрица роль→раздел берётся из
// того же mainMenu, что и видимость меню, — чтобы доступ и меню не разъезжались.
function findGatedItem(path) {
  for (const section of mainMenu) {
    for (const item of section.items) {
      if (path === item.url || path.startsWith(item.url + "/")) {
        return item;
      }
    }
  }
  return null;
}

const router = createRouter({
  history: createWebHistory(),
  routes,
  // Use the HTML5 history API (i.e. normal-looking routes)
  // instead of routes with hashes (e.g. example.com/#/about).
  // This may require some server configuration in production:
  // https://router.vuejs.org/en/essentials/history-mode.html#example-server-configurations
  mode: "history",
  // Simulate native-like scroll behavior when navigating to a new
  // route and using back/forward buttons.
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { top: 0, left: 0 };
    }
  },
});

router.beforeEach(async (routeTo, routeFrom, next) => {
  const authStore = useAuthStore();
  if (!userStoreInitialised) {
    userStoreInitialised = true;
    const res = await authStore.initStore();
    if (res === true) {
      return next();
    }
  }
  const publicPages = ["/login", "/register", "/recovery"];
  const authpage = !publicPages.includes(routeTo.path) && routeTo.name !== "NotFound";
  const loggeduser = computed(() => authStore.isAuthorised);

  if (authpage && !loggeduser.value) {
    return next("/login");
  }

  if (authpage && loggeduser.value) {
    const item = findGatedItem(routeTo.path);
    if (item) {
      const roles = collectUserRoles(authStore.user);
      const allowed = item.roles.some((r) => roles.includes(r));
      if (!allowed) {
        return next({ name: "Forbidden" });
      }
    }
  }

  next();
});

export default router;
